/*=========================================================================================
  File Name: moduleEmployeeGetters.js
  Description: Employee Module Getters
==========================================================================================*/
import _ from "lodash";

export default {
	queriedEmployees: state =>
		state.employees.filter(employee => {
			let isItemOfCurrentFilter = false;

			if (
				(state.employeesFilter === "all" && !employee.isTrashed) ||
				(state.employeesFilter === "trashed" && employee.isTrashed)
			) {
				isItemOfCurrentFilter = true;
			}

			return (
				isItemOfCurrentFilter &&
				(employee.title
					.toLowerCase()
					.includes(state.employeesSearchQuery.toLowerCase()) ||
					employee.desc
						.toLowerCase()
						.includes(state.employeesSearchQuery.toLowerCase()))
			);
		}),
	getEmployee: state => employeeId =>
		state.employees.find(employee => employee.id === employeeId),
	getParsedEmployees: state =>
		state.employees.map(employee => ({
			...employee,
			titleName: _.get(employee, "title.name") || "",
			departmentName: _.get(employee, "department.name") || ""
		}))
};
